import { Box, Typography } from "@mui/material"
import { blueGrey } from "@mui/material/colors"
import theme from "@/styles/theme"

const currentYear = new Date().getFullYear()

export function Footer() {
  return (
    <Box
      component={"footer"}
      sx={{ background: theme.gradient.main }}
      width={"100%"}
    >
      <Box
        display={"flex"}
        justifyContent={"space-between"}
        alignItems={"center"}
        paddingInline={3}
        paddingBlock={1.5}
      >
        <Typography
          color={blueGrey["50"]}
          fontSize={11}
          fontFamily={"K2D, Arial, sans-serif"}
          textTransform={"uppercase"}
        >
          Plataforma Responsável de Inteligência Artificial
        </Typography>

        <Typography
          sx={{ opacity: 0.8 }}
          color={blueGrey["50"]}
          fontSize={10}
          fontFamily={"K2D, Arial, sans-serif"}
          textTransform={"uppercase"}
        >
          © {currentYear} Todos os direitos reservados.
        </Typography>
      </Box>
    </Box>
  )
}
